import { DatePipe } from '@angular/common';

import { Client, Machine, Seller, Dealership } from './';
import { formatUtcDDMMYYYY } from '../shared/utils/date-format';

export class AssemblyOrder {
  id?: string;
  id_client: string;
  id_machine: string;
  id_seller: string;
  id_dealership: string;
  idClient?: number;
  idMachine?: number;
  idSeller?: number;
  idDealership?: number;
  client?: Client;
  machine?: Machine;
  seller?: Seller;
  dealership?: Dealership;
  createdAt?: string;
  hide = false;
  details?: string;
  name: string;
  chasis: string;
  deliveryDate: string;
  scheduledDate: string;
  description: string;
  generalDescription: string;


  // added by FE
  finished?: boolean;

  datePipe?: DatePipe;

  constructor(assemblyOrder?) {
    if (assemblyOrder.id) { this.id = assemblyOrder.id; }
    this.id_client = assemblyOrder.id_client;
    this.id_machine = assemblyOrder.id_machine;
    this.id_seller = assemblyOrder.id_seller;
    this.id_dealership = assemblyOrder.id_dealership;
    if (assemblyOrder.client) { this.client = new Client(assemblyOrder.client); }
    if (assemblyOrder.machine) { this.machine = new Machine(assemblyOrder.machine); }
    if (assemblyOrder.seller) { this.seller = new Seller(assemblyOrder.seller); }
    if (assemblyOrder.dealership) { this.dealership = new Dealership(assemblyOrder.dealership); }
    if (assemblyOrder.idClient) { this.client = assemblyOrder.idClient; }
    if (assemblyOrder.idMachine) { this.machine = assemblyOrder.idMachine; }
    if (assemblyOrder.idSeller) { this.seller = assemblyOrder.idSeller; }
    if (assemblyOrder.idDealership) { this.dealership = assemblyOrder.idDealership; }
    if (assemblyOrder.createdAt) {
      this.createdAt = formatUtcDDMMYYYY(assemblyOrder.createdAt);
    }
    if (assemblyOrder.hide) { this.hide = assemblyOrder.hide; }
    if (assemblyOrder.details) { this.details = assemblyOrder.details; }
    this.finished = assemblyOrder.workplanAssemblyOrder ? assemblyOrder.workplanAssemblyOrder.finished : false;
    if (this.client && this.machine) { this.name = `${this.machine.name} - ${this.client.fullname}`; }
    if (assemblyOrder.chasis) { this.chasis = assemblyOrder.chasis; }
    if (assemblyOrder.deliveryDate) { this.deliveryDate = assemblyOrder.deliveryDate; }
    if (assemblyOrder.scheduledDate) { this.scheduledDate = assemblyOrder.scheduledDate; }
    if (assemblyOrder.description) { this.description = assemblyOrder.description; }
    if (assemblyOrder.generalDescription) { this.generalDescription = assemblyOrder.generalDescription; }
  }
}
